// Global
import React from 'react';

export const FeatureDecor = () => {
  return <></>;
};
